<ng-container
  *ngrxLet="activeHemsType$ | async | value2: featurePropertyKey.activeHemsType as activeHemsType"
>
  <app-banner
    data-at-hems-lite-banner
    type="info"
    [title]="'+INSTALLATIONS.INSTALLATION.HEMS.LITE.BANNER.TITLE' | translate"
    [linkLabel]="'+INSTALLATIONS.INSTALLATION.HEMS.LITE.BANNER.LEARN_MORE' | translate"
    [linkInNewLine]="true"
    (clickEvent)="openHemsLiteHelp()"
    *ngIf="activeHemsType === hemsType.Lite"
    class="mt-4"
  >
    {{ '+INSTALLATIONS.INSTALLATION.HEMS.LITE.BANNER.DESCRIPTION' | translate }}
  </app-banner>

  <app-banner
    data-at-hems-disabled-banner
    [title]="'+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_MANAGEMENT_NOT_ACTIVE.TITLE' | translate"
    *ngIf="
      activeHemsType === hemsType.None ||
      activeHemsType === hemsType.NotConfigured ||
      activeHemsType === hemsType.LiteReady
    "
  >
    <span data-at-hems-disabled-energy-banner-content>
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_MANAGEMENT_NOT_ACTIVE.DESCRIPTION' | translate }}
    </span>
  </app-banner>
  <app-feature-list-container>
    <h2
      class="flex-auto"
      data-at-electrical-production-title
      data-at-hems-energy-cockpit-section-title
    >
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_COCKPIT.TITLE' | translate }}
    </h2>

    <app-banner
      *ngIf="consumptionLimitation$ | async as consumptionLimitation"
      class="mt-4"
      [title]="
        '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_COCKPIT.CONSUMPTION_LIMITATION.TITLE' | translate
      "
    >
      {{
        '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_COCKPIT.CONSUMPTION_LIMITATION.DESCRIPTION'
          | translate
            : {
                value: consumptionLimitation | featureLike | value2: featurePropertyKey.value,
                unit: consumptionLimitation | featureLike | unit: featurePropertyKey.value
              }
      }}
    </app-banner>

    <app-banner
      *ngIf="productionLimitation$ | async as productionLimitation"
      class="mt-4"
      [title]="
        '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_COCKPIT.FEED_IN_LIMITATION.TITLE' | translate
      "
    >
      {{
        '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_COCKPIT.FEED_IN_LIMITATION.DESCRIPTION'
          | translate
            : {
                value: productionLimitation | featureLike | value2: featurePropertyKey.value,
                unit: productionLimitation | featureLike | unit: featurePropertyKey.value
              }
      }}
    </app-banner>

    <div
      *ngIf="(heatingSpfTotal$ | async) && powerBalance"
      class="flow-btns-container flex flex-row justify-center items-center"
    >
      <button
        mat-button
        color="primary"
        [ngClass]="
          !isThermalFlow ? 'mat-mdc-raised-button selected-flow-btn' : 'mat-mdc-stroked-button'
        "
        [class.blocked]="!isThermalFlow"
        (click)="onSelectFlowType(FLOW_TYPES.Power)"
        gtm="onSelect"
        gtmAction="Power flow"
        gtmCategory="hems"
      >
        {{ '+INSTALLATIONS.INSTALLATION.HEMS.POWER' | translate }}
      </button>
      <button
        mat-button
        color="primary"
        [ngClass]="
          isThermalFlow ? 'mat-mdc-raised-button selected-flow-btn' : 'mat-mdc-stroked-button'
        "
        [class.blocked]="isThermalFlow"
        (click)="onSelectFlowType(FLOW_TYPES.Thermal)"
        gtm="onSelect"
        gtmAction="Thermal flow"
        gtmCategory="hems"
      >
        {{ '+INSTALLATIONS.INSTALLATION.HEMS.THERMAL' | translate }}
      </button>
    </div>
    <div class="overview-wrapper">
      <ng-container *ngIf="isThermalFlow">
        <div class="consumption-wrapper">
          <div class="img-wrapper">
            <img
              [src]="
                activeHemsType === hemsType.Full
                  ? 'assets/img/hems-house-thermal-full.svg'
                  : 'assets/img/hems-house-thermal.svg'
              "
              alt="HEMS house power flow"
            />
          </div>
        </div>
        <div class="consumption-details-wrapper">
          <div class="current-values-container">
            <h4 data-at-energy-flow-what-goes-in-title>
              {{ '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_GOES_IN.TITLE' | translate }}
            </h4>
            <div class="flow-item">
              <div class="flow-item__caption">
                <vi-icon icon name="electricity" [size]="24"></vi-icon>
                {{
                  '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_GOES_IN.ELECTRICITY'
                    | translate
                }}
              </div>
              <div *ngIf="thermalCockpit$ | async as feature" class="flow-item__value">
                {{ feature | value2: featurePropertyKey.electricityInput }}
                {{ feature | unit: featurePropertyKey.electricityInput }}
              </div>
            </div>
          </div>
          <div class="current-values-container">
            <h4 data-at-energy-flow-where-it-goes-title>
              {{ '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.TITLE' | translate }}
            </h4>
            <div *ngIf="thermalCockpit$ | async as feature" class="flow-item">
              <div class="flow-item__caption">
                <vi-icon
                  icon
                  [name]="
                    feature.properties?.thermalOutput?.value >= 0 ? 'thermal-output' : 'frost'
                  "
                  [size]="24"
                ></vi-icon>
                {{
                  '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.THERMAL_OUTPUT'
                    | translate
                }}
              </div>
              <div class="flow-item__value">
                {{ feature | value2: featurePropertyKey.thermalOutput }}
                {{ feature | unit: featurePropertyKey.thermalOutput }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isThermalFlow && powerBalance">
        <div class="consumption-wrapper">
          <div class="img-wrapper">
            <img src="assets/img/hems-house-power.svg" alt="HEMS house power flow" />
          </div>
          <div *ngIf="indicators$ | async as indicators" class="consumption-summary-wrapper">
            <app-circle-progress-bar
              [size]="125"
              [color]="'#3C9639'"
              [percent]="indicators?.properties?.autarky?.value | calculationStatus: powerBalance"
              [roundPercent]="true"
              [descriptionKey]="'+INSTALLATIONS.INSTALLATION.HEMS.AUTARKY'"
              class="progress-bar"
            ></app-circle-progress-bar>
            <app-circle-progress-bar
              [size]="125"
              [color]="'#FFC938'"
              [percent]="
                indicators?.properties?.selfConsumption?.value | calculationStatus: powerBalance
              "
              [roundPercent]="true"
              [descriptionKey]="'+INSTALLATIONS.INSTALLATION.HEMS.SELF_CONSUMPTION'"
              class="progress-bar"
            ></app-circle-progress-bar>
          </div>
        </div>
        <div class="consumption-details-wrapper">
          <div class="current-values-container">
            <h4 data-at-energy-flow-what-goes-in-title>
              {{
                '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_GOES_IN.TITLE_ELECTRICITY'
                  | translate
              }}
            </h4>
            <div *ngFor="let item of powerBalance.properties?.delivered?.value" class="flow-item">
              <div class="flow-item__caption">
                <ng-container [ngSwitch]="item.type">
                  <vi-icon
                    *ngSwitchCase="ENERGY_FLOW_IN_TYPE.Photovoltaic"
                    icon
                    name="solar-collector"
                    [size]="24"
                  ></vi-icon>
                  <vi-icon
                    *ngSwitchCase="ENERGY_FLOW_IN_TYPE.Grid"
                    icon
                    name="grid-consumption"
                    [size]="24"
                  ></vi-icon>
                  <vi-icon
                    *ngSwitchCase="ENERGY_FLOW_IN_TYPE.Accumulator"
                    icon
                    name="battery-discharge-cumulated"
                    [size]="24"
                  ></vi-icon>
                </ng-container>
                <span class="flow-item__caption__name">
                  {{ item.type | translateEnergyFlowType: ENERGY_FLOW_DIRECTIONS.In }}
                </span>
                <!-- stateOfCharge -->
                <span
                  *ngIf="
                    item.type === emsPowerBalanceTypes.Accumulator && stateOfCharge$
                      | async
                      | ready as stateOfCharge
                  "
                >
                  &nbsp;({{ stateOfCharge | value2: featurePropertyKey.value }}
                  {{ stateOfCharge | unit: featurePropertyKey.value }})</span
                >
                <!-- stateOfChargeConsolidated -->
                <span
                  *ngIf="
                    item.type === emsPowerBalanceTypes.Accumulator && stateOfChargeConsolidated$
                      | async
                      | ready as stateOfChargeConsolidated
                  "
                >
                  &nbsp;({{ stateOfChargeConsolidated | value2: featurePropertyKey.total }}
                  {{ stateOfChargeConsolidated | unit: featurePropertyKey.total }})</span
                >
              </div>
              <div class="flow-item__value">
                {{
                  getPropertiesAsFeatureLike(item)
                    | value2: featurePropertyKey.value
                    | calculationStatus: powerBalance
                }}
                {{
                  getPropertiesAsFeatureLike(item)
                    | unit: featurePropertyKey.value
                    | calculationStatus: powerBalance
                }}
              </div>
            </div>
          </div>
          <div class="current-values-container">
            <h4 data-at-energy-flow-where-it-goes-title>
              {{
                '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.TITLE_ELECTRICITY'
                  | translate
              }}
            </h4>
            <ng-container *ngFor="let key of powerBalanceOrder">
              <ng-container
                *ngIf="
                  key !== emsPowerBalanceTypes.dryContactGeneric;
                  else dryContactGenericPowerDetails
                "
              >
                <div
                  *ngFor="let item of powerBalanceTypeToValueMap.get(key) || []"
                  class="flow-item"
                >
                  <div class="flow-item__caption">
                    <ng-container [ngSwitch]="item.type">
                      <vi-icon
                        *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.Accumulator"
                        icon
                        name="battery-charging"
                        [size]="24"
                      ></vi-icon>
                      <vi-icon
                        *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.Grid"
                        icon
                        name="grid-feed-in"
                        [size]="24"
                      ></vi-icon>
                      <vi-icon
                        *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.Household"
                        icon
                        name="home"
                        [size]="24"
                      ></vi-icon>
                      <vi-icon
                        *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.Heatpump"
                        icon
                        name="heatpump"
                        [size]="24"
                      ></vi-icon>
                      <vi-icon
                        *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.DryContactHeatpump"
                        icon
                        name="heatpump"
                        [size]="24"
                      ></vi-icon>
                      <ng-container *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.VCS">
                        <vi-icon *ngIf="!isOBNG" icon name="charging-station" [size]="24"></vi-icon>
                        <vi-icon
                          *ngIf="isOBNG"
                          icon
                          name="charging-station-obng"
                          [size]="24"
                        ></vi-icon>
                      </ng-container>
                      <vi-icon
                        *ngSwitchCase="ENERGY_FLOW_OUT_TYPE.PhotovoltaicsHeater"
                        icon
                        name="pv-immersion-heater"
                        [size]="24"
                      ></vi-icon>
                    </ng-container>
                    <div class="flow-item__caption__wrapper">
                      <span
                        *ngIf="isOBNG && item.type === emsPowerBalanceTypes.VCS; else defaultName"
                      >
                        {{
                          item.busAddress | wallboxNameByBusAddress: wallboxNamesWithBusAddress
                        }}</span
                      >
                      <ng-template #defaultName>
                        <span class="flow-item__caption__name">{{
                          item.type | translateEnergyFlowType: ENERGY_FLOW_DIRECTIONS.Out
                        }}</span>
                      </ng-template>
                      <div
                        class="flow-item__caption__description"
                        *ngIf="
                          item.type === emsPowerBalanceTypes.Heatpump &&
                          (heatingRodNotificationVisible$ | async)
                        "
                      >
                        {{
                          '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.DESCRIPTION_HEAT_PUMP'
                            | translate
                        }}
                      </div>
                    </div>
                    <span
                      *ngIf="
                        item.type === emsPowerBalanceTypes.Accumulator &&
                        (stateOfChargeConsolidated$ | async | ready) as stateOfChargeConsolidated
                      "
                    >
                      &nbsp;({{ stateOfChargeConsolidated | value2: featurePropertyKey.total }}
                      {{ stateOfChargeConsolidated | unit: featurePropertyKey.total }})</span
                    >
                  </div>

                  <div class="flow-item__value">
                    {{
                      getPropertiesAsFeatureLike(item)
                        | value2: featurePropertyKey.value
                        | calculationStatus: powerBalance
                    }}
                    {{
                      getPropertiesAsFeatureLike(item)
                        | unit: featurePropertyKey.value
                        | calculationStatus: powerBalance
                    }}
                  </div>
                </div>
              </ng-container>
              <ng-template #dryContactGenericPowerDetails>
                <ng-container *ngFor="let item of dryContactgenericDevicePowerDetails">
                  <div class="flow-item">
                    <div class="flow-item__caption">
                      <vi-icon icon name="dry-contact" [size]="24"></vi-icon>
                      <div class="flow-item__caption__wrapper">
                        <span class="flow-item__caption__name">{{ item.name }}</span>
                      </div>
                    </div>
                    <div class="flow-item__value">
                      {{
                        getPropertiesAsFeatureLike(item)
                          | value2: featurePropertyKey.value
                          | calculationStatus: powerBalance
                      }}
                      {{
                        getPropertiesAsFeatureLike(item)
                          | unit: featurePropertyKey.value
                          | calculationStatus: powerBalance
                      }}
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </ng-container>
          </div>
          <ng-container
            *ngIf="(pvStatus$ | async | ready | value2: featurePropertyKey.status) === 'production'"
          >
            <div class="current-values-container" *ngIf="powerFlows$ | async as feature">
              <h4 data-at-energy-flow-what-was-consumed>
                {{
                  '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_WAS_CONSUMED.TITLE'
                    | translate
                }}
              </h4>
              <div class="flow-item">
                <div class="flow-item__caption">
                  <vi-icon icon name="self-consumption" [size]="24"></vi-icon>
                  <span class="flow-item__caption__name">
                    {{
                      '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_WAS_CONSUMED.DIRECT_CONSUMPTION'
                        | translate
                    }}
                  </span>
                </div>
                <div class="flow-item__value">
                  {{ feature | value2: featurePropertyKey.productionToConsumption }}
                  {{ feature | unit: featurePropertyKey.productionToConsumption }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </app-feature-list-container>
</ng-container>
